import React from "react";
import { Rocket } from "lucide-react";
import { ScheduleSettings, SearchSettings } from "./autopilot/AutopilotSettings";
import AutopilotLog from "./autopilot/AutopilotLog";
import AgentStatus from "./autopilot/AgentStatus";
import AutopilotSwitch from "./autopilot/AutopilotSwitch";
import { useAutopilot } from "./autopilot/useAutopilot";

const AutopilotPanel = ({ isMaster = true }) => {
  const { s, logs, sentToday, status, error, saving, running, load, patch, save, toggleEnabled, runNow } = useAutopilot();

  if (error) return <p className="text-red-600 text-sm" data-testid="autopilot-error">{error}</p>;
  if (!s) return <p className="text-neutral-500">Chargement...</p>;

  return (
    <div>
      <div className="flex items-center gap-2 mb-1">
        <Rocket size={20} className="text-brand" />
        <h2 className="font-heading font-bold text-xl text-neutral-900">Pilote automatique de prospection</h2>
      </div>
      <p className="text-sm text-neutral-500 mb-5">
        Recherche automatique d'entreprises → import en prospects → envoi des emails de prospection dans la plage horaire dédiée, avec relances.
      </p>

      <AgentStatus job={status.jobs.autopilot} cronConfigured={status.cron} />
      <AutopilotSwitch s={s} sentToday={sentToday} running={running} isMaster={isMaster} onRun={runNow} onToggle={toggleEnabled} />

      {isMaster && (
        <>
          <div className="grid lg:grid-cols-2 gap-5">
            <ScheduleSettings s={s} patch={patch} />
            <SearchSettings s={s} patch={patch} />
          </div>
          <button onClick={() => save()} disabled={saving} data-testid="autopilot-save-btn" className="mt-5 bg-brand hover:bg-brand-dark text-white font-semibold px-6 py-2.5 rounded-md disabled:opacity-60">
            {saving ? "Enregistrement..." : "Enregistrer les paramètres"}
          </button>
        </>
      )}

      <AutopilotLog logs={logs} onRefresh={load} />
    </div>
  );
};

export default AutopilotPanel;
